import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule, CurrencyPipe } from '@angular/common';
import { SidebarComponent } from '@app/feature/store-admin/components/sidebar/sidebar.component';
import { DashboardComponent } from '@app/feature/store-admin/components/dashboard/dashboard.component';
import { StoreAdminRouting } from '@app/feature/store-admin/store-admin-routing.module';
import { CreateStoreComponent } from '@app/feature/store-admin/components/create-store/create-store.component';
import { StoreListComponent } from '@app/feature/store-admin/components/store-list/store-list.component';
import { StorelayoutComponent } from '@app/feature/store-admin/components/storelayout/storelayout.component';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { EditStoreComponent } from '@app/feature/store-admin/components/edit-store/edit-store.component';
import { HeaderComponent } from '@app/feature/store-admin/components/storeAdmin-header/header.component';
import { MaterialModule } from '@app/material/material.module';
import { ColorPickerModule } from 'ngx-color-picker';
import { DesignListComponent } from '@app/feature/store-admin/components/design/design-list/design-list.component';
import { UploadDesignComponent } from '@app/feature/store-admin/components/design/upload-design/upload-design.component';
import { EditDesignComponent } from '@app/feature/store-admin/components/design/edit-design/edit-design.component';
import { SharedModule } from '@app/shared/shared.module';
import { InfiniteScrollDirective, InfiniteScrollModule } from 'ngx-infinite-scroll';
import { ApplyDesignComponent } from './components/design/apply-design/apply-design.component';
import { ProductListComponent } from './components/product/product-list/product-list.component';
import { StoreadminProfileComponent } from './components/storeadmin-profile/storeadmin-profile.component';
import { CustomizedProductComponent } from './components/product/customized-product/customized-product.component';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { StoreAdminCommissionListComponent } from './components/store-admin-commission-list/store-admin-commission-list.component';
import { StoreAdminEarningRptComponent } from './components/reports/store-admin-earning-rpt/store-admin-earning-rpt.component';
import { OrderSalesReportComponent } from './components/reports/order-sales-report/order-sales-report.component';
// import {CountoModule} from 'angular2-counto';
import { Router, RouterLink } from '@angular/router';
import { PublishedProductComponent } from './components/published-product/published-product.component';
import { AddStoreCategoryComponent } from './components/store-category/add/add-store-category.component';
import { EditStoreShopifyPopupComponent } from './components/edit-store-shopify-popup/edit-store-shopify-popup.component';
import { OrderShopifyComponent } from '@app/feature/store-admin/components/reports/order-shopify/order-shopify.component';
import { WelcomeScreenComponent } from './components/welcome-screen/welcome-screen.component';
import { PopupSelectStoreComponent } from './components/popup-select-store/popup-select-store.component';
import { AddProductPopupComponent } from '@app/feature/store-admin/components/add-product-popup/add-product-popup.component';
import { TrackingNumberPopupComponent } from './components/reports/tracking-number-popup/tracking-number-popup.component';
import { AddProductPopupCustomizeComponent } from './components/add-product-popup-customize/add-product-popup-customize.component';
import { MatTableModule } from '@angular/material/table';
import { MatTreeModule } from '@angular/material/tree';
import { NgxPayPalModule } from 'ngx-paypal';
import { DashboardCountSubComponentComponent } from './components/dashboard/dashboard-count/dashboard-count-sub-component.component';
import { StoreListItemSubComponentComponent } from './components/store-list-item-sub-component/store-list-item-sub-component.component';
import { OrderFilterComponent } from '@app/feature/store-admin/components/reports/order-shopify/order-filter/order-filter.component';
import { NoOrderComponent } from './components/reports/order-shopify/no-order/no-order.component';
import { StoreService } from '@app/feature/store-admin/services/store.service';
import { UploadDesignService } from '@app/feature/store-admin/services/uploadDesign/uploadDesign.service';
import { StoreListingResolver } from '@app/feature/store-admin/routeresolver/storelistingresolver';
import { StoreCategoryService } from '@app/feature/store-admin/services/storeCategory/store-category.service';
import { EndUserModule } from '@app/feature/end-user/end-user.module';
import { StoreadminInvoicelistComponent } from './components/storeadmin-invoicelist/storeadmin-invoicelist.component';
import { UploadProductImageDialogComponent } from './components/upload-product-image-dialog/upload-product-image-dialog.component';
import { ImageCropperComponent } from 'ngx-image-cropper';
import { ReportBugComponent } from './components/report-bug/report-bug.component';
import { RequestColorComponent } from './components/request-color/request-color.component';
import { W9SFormComponent } from './components/w9-sform/w9-sform.component';
import { NgxMaskDirective, NgxMaskPipe, provideNgxMask } from 'ngx-mask';
import { CreateSampleOrderComponent } from './components/create-sample-order/create-sample-order.component';
import { AddCustomProductComponent } from './components/add-custom-product/add-custom-product.component';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { WarehouseProductListingComponent } from './components/warehouse-product-listing/warehouse-product-listing.component';
import { InventoryDetailsComponent } from './components/inventory-details/inventory-details.component';
import { StateService } from '@app/shared/services/state/state.service';
import { TeamComponent } from './components/team/team.component';
import { TeamInviteComponent } from './components/team-invite/team-invite.component';
import { SettingComponent } from './components/setting/setting.component';
import { PermissionComponent } from './components/permission/permission.component';
import { BaseChartDirective } from 'ng2-charts';
import { MatInputModule } from '@angular/material/input';
import { HuddleFlowModule } from '@app/shared/modules/huddle-flow/huddle-flow.module';

@NgModule({
  imports: [
    CommonModule,
    StoreAdminRouting,
    ReactiveFormsModule,
    HttpClientModule,
    MaterialModule,
    RouterLink,
    ColorPickerModule,
    SharedModule,
    InfiniteScrollModule,
    // CountoModule,
    FormsModule,
    MatTableModule,
    NgxPayPalModule,
    EndUserModule,
    MatTreeModule,
    ImageCropperComponent,
    NgxMaskDirective,
    NgxMaskPipe,
    NgMultiSelectDropDownModule.forRoot(),
    InfiniteScrollDirective,
    BaseChartDirective,
    MatInputModule,
    CurrencyPipe,
    HuddleFlowModule
   
  ],
  declarations: [
    StorelayoutComponent,
    HeaderComponent,
    TrackingNumberPopupComponent,
    AddProductPopupCustomizeComponent,
    InventoryDetailsComponent,
    SettingComponent,
    StoreListComponent,
    StoreListItemSubComponentComponent,
    EditStoreComponent,
    DesignListComponent,
    W9SFormComponent,
    AddCustomProductComponent,
    WarehouseProductListingComponent,
    ApplyDesignComponent,
    EditDesignComponent,
    UploadDesignComponent,
    CreateStoreComponent,
    SidebarComponent,
    StoreadminProfileComponent,
    CustomizedProductComponent,
    StoreAdminCommissionListComponent,
    OrderSalesReportComponent,
    StoreAdminEarningRptComponent,
    PublishedProductComponent,
    AddStoreCategoryComponent,
    EditStoreShopifyPopupComponent,
    WelcomeScreenComponent,
    PopupSelectStoreComponent,
    DashboardCountSubComponentComponent,
    OrderFilterComponent,
    NoOrderComponent,
    StoreadminInvoicelistComponent,
    CreateSampleOrderComponent,
    ReportBugComponent,
    UploadProductImageDialogComponent,
    ReportBugComponent, 
    W9SFormComponent, 
    CreateSampleOrderComponent, 
    AddCustomProductComponent, 
    WarehouseProductListingComponent, 
    InventoryDetailsComponent,
    RequestColorComponent,
    TeamComponent,
    TeamInviteComponent,
    PermissionComponent,
    AddProductPopupComponent,
    OrderShopifyComponent,
    ProductListComponent,
    UploadProductImageDialogComponent,
    DashboardComponent

  ],
  providers: [
    StoreService,
    UploadDesignService,
    StoreListingResolver,
    StoreCategoryService,
    StateService,
    CurrencyPipe,
    provideNgxMask()
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class StoreAdminModule {
  constructor(private router: Router) {

    router.events.subscribe((event: any) => {
      const a = $(window).height();
      const d = $('.footer').height() + 100;
      const e = a - d;
      $('.content-blk').css('min-height', e);
    });
  }
}
